import { LinkQueryResult } from '../traceInspector.types';
import { AvatarComponent } from '@/components/ui/avatar/avatar';
import { getLinkCreatedBy } from '@/components/traceInspector/segmentUserDetail/segmentUserDetail.utils';

type Props = {
  link: LinkQueryResult;
  linkCreatedByAccount: any;
};

/**
 * Links are created by an account.
 * However, its entity can be null if the current user is a collaborator
 * and the entity is not visible to the group.
 * The display falls back to the link group in that case.
 */
export const SegmentUserDetail = ({ link, linkCreatedByAccount }: Props) => {
  const createdBy = getLinkCreatedBy(link, linkCreatedByAccount);

  if (!createdBy) {
    return (
      <div className="border-border text-foreground flex w-full items-center gap-2 border-b pb-4 break-words">
        <div className="mr-2 shrink-0 pt-1">
          <AvatarComponent
            source={link.group.avatar}
            name={link.group.name}
            size={44}
          />
        </div>
        <div>
          <div className="flex w-full items-start gap-4 px-1">
            <div className="mr-2 text-lg font-semibold">{link.group.name}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="border-border text-foreground flex w-full items-center gap-2 border-b pb-4 break-words">
      <div className="mr-2 shrink-0 pt-1">
        <AvatarComponent
          source={createdBy.avatar}
          name={createdBy.name}
          size={44}
        />
      </div>
      <div>
        <div className="flex w-full items-center gap-4 py-1">
          <div className="mr-2 text-lg font-semibold">{createdBy.name}</div>
        </div>
        <div className="text-muted-foreground text-sm">
          {createdBy.email && (
            <div>
              <a
                className="hover:text-primary text-inherit no-underline"
                href={`mailto:${createdBy.email}`}
              >
                {createdBy.email}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
